import { render, staticRenderFns } from "./LeadCards.vue?vue&type=template&id=225916f0&scoped=true&"
import script from "./LeadCards.vue?vue&type=script&lang=js&"
export * from "./LeadCards.vue?vue&type=script&lang=js&"
import style0 from "./LeadCards.vue?vue&type=style&index=0&id=225916f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225916f0",
  null
  
)

export default component.exports